"use client";

import React from "react";
import {Table, TableHeader, TableColumn, TableBody, TableRow, TableCell} from "@heroui/table";

export default function Cookies() {
    return (
        <div style={{
            padding:"6rem 1.66rem",
            display:"flex",
            flexDirection:"column",
            // gap:"1.6rem",
            gap:"3rem",
            minHeight:"37.55rem",
            maxWidth:"1280px",
            margin:"0 auto",
        }}>
            <>
                <title>Bruk av informasjonskapsler | Ascendi</title>
                <link rel="canonical" href="https://www.ascendi.no/privacy/cookies/"/>
            </>
            <div>
                <h2 className="font-bold text-large mb-1">Informasjonskapsler <span className="text-foreground/60">(Cookies)</span></h2>
                <p className="max-w-3xl w-full text-foreground/90">
                    Informasjonskapsler er små tekstfiler som plasseres på din datamaskin når du laster ned en nettside. 
                    Disse filene brukes til å forbedre brukeropplevelsen. I vårt tilfelle er alle informasjonskapslene 
                    relatert til sidens tilgjengelighet, slik at du kan være sikker på at finner oss her 24/7.
                </p>
            </div>
            <Table aria-label="Oversikt over informasjonskapsler"
                // classNames={{ base:"max-w-screen-xl" }}
            >
                <TableHeader>
                    <TableColumn>Navn</TableColumn>
                    <TableColumn>Formål</TableColumn>
                    <TableColumn>Valgfri</TableColumn>
                    <TableColumn>Lagringstid</TableColumn>
                    <TableColumn>Mottaker</TableColumn>
                </TableHeader>
                <TableBody>
                    <TableRow key="1">
                        <TableCell>__cf_bm</TableCell>
                        <TableCell className="max-w-80 min-w-48">
                            Brukes til å skille ekte brukere fra ondsinnede botter.
                        </TableCell>
                        <TableCell>Nei</TableCell>
                        <TableCell>30 minutter</TableCell>
                        <TableCell>Cloudflare</TableCell>
                    </TableRow>
                    <TableRow key="2">
                        <TableCell>cf_ob_info</TableCell>
                        <TableCell className="max-w-80 min-w-48">
                            Bidrar, sammen med cf_use_ob, til å gjøre nettsiden tilgjengelig selv om våre servere slutter å fungere.
                        </TableCell>
                        <TableCell>Nei</TableCell>
                        <TableCell>30 minutter</TableCell>
                        <TableCell>Cloudflare</TableCell>
                    </TableRow>
                    <TableRow key="3">
                        <TableCell>cf_use_ob</TableCell>
                        <TableCell className="max-w-80 min-w-48">
                            Bidrar, sammen med cf_ob_info, til å gjøre nettsiden tilgjengelig selv om våre servere slutter å fungere.
                        </TableCell>
                        <TableCell>Nei</TableCell>
                        <TableCell>30 minutter</TableCell>
                        <TableCell>Cloudflare</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>
    )
}